// extracted by mini-css-extract-plugin
export var tuitionRates = "tuitionRates-module--tuition-rates--pbd9e";
export var tuitionRatesWrap = "tuitionRates-module--tuition-rates-wrap--L5bqQ";